import { render, staticRenderFns } from "./frozenButton.vue?vue&type=template&id=1cab01c2&"
import script from "./frozenButton.vue?vue&type=script&lang=js&"
export * from "./frozenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports